import useDefinedContext from "hooks/useDefinedContext";
import SelectedEntitiesContext from "../SelectedEntitiesContext";

function useSelectedEntities<T = never, K = T extends any ? Array<T> : never>() {
  return useDefinedContext(SelectedEntitiesContext) as K;
}

export default useSelectedEntities;
